"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyDefinition = void 0;
const firestore_1 = require("comodel/firestore");
const project_1 = require("./project");
exports.keyDefinition = (0, firestore_1.defineCollection)({
    collectionName: "key",
    idKey: "userId",
    parent: project_1.projectDefinition,
    constraints: ["projectId"],
    queryDefs: {},
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
